<template>
  <DefaultLayout>
    <template slot="top">
      <b-alert v-if="paymentSuccess" dismissible show="" variant="success">Votre abonnement a été payé</b-alert>
      <h1 class="title">Bonjour <strong>{{ user.last_name }}</strong>,</h1>
    </template>
    <template slot="left">
      <left-sidebar-top></left-sidebar-top>
      <!-- the second white container on the leftsidebar -->
      <left-sidebar-bottom class="mt-2"></left-sidebar-bottom>
    </template>
    <template slot="center">
      <left-sidebar-top class="mb-3" v-if="mobile"></left-sidebar-top>
      <div class="white-card px-2 pt-0 pb-4 mb-3">
        <div class="loader absolute" v-if="loading"></div>
        <div class="row mx-0">
          <div class="col-md-7 mr-auto">
            <img src="@img/male.svg" alt="" class="img-fluid" v-if="user.gender === 'M'">
            <img src="@img/female.svg" alt="" class="img-fluid" v-else>
          </div>
          <div class="col-md-5 ml-auto pt-4 pr-5" v-if="last_content && last_content.type">
            <div style="font-size: 12px">
              <span class="d-block">Continue ton apprentissage là où nous nous sommes arretés la derniere fois?</span>
              <div class="d-flex align-items-start my-2">
                <img style="width: 60px" class="img-fluid mr-2" :src="last_content.img || last_content.subject_logo">
                <div>
                  <span class="badge badge-success">{{ badge }}</span>
                  <p class="mb-1">{{ last_content.title || last_content.lesson_title }}</p>
                  <span class="bg-gray d-inline-block p-1 rounded-5" style="font-size: 10px">
                      <span class="fa fa-clock fz-14 mr-1"></span>
                  {{ moment(last_content.date).fromNow() }}
                    </span>
                </div>
              </div>
              <router-link tag="a" :to="content_link" class="btn btn-outline-green btn-sm">Continuer
              </router-link>
            </div>
          </div>
        </div>
        <div v-if="stats" class="mt-3 text-center text-capitalize">
          <h3>Statistiques</h3>
          <div class="d-flex justify-content-center">
            <div class="fz-15 border-right d-flex align-items-center flex-column px-3">
              <strong class="text-green fz-68">{{ stats.video_count }}</strong>
              <small class="w_70 text-center">
                Videos Consultees
              </small>
            </div>
            <div class="fz-15 d-flex align-items-center flex-column px-3">
              <strong class="text-primary fz-68">{{ stats.content_count }}</strong>
              <small class="w_70 text-center">
                Contenus vus
              </small>
            </div>
          </div>
        </div>
        <div class="mt-3 px-2">
          <next-conferences></next-conferences>
        </div>
        <div class=" mt-3 px-2">
          <subject-list></subject-list>
        </div>
      </div>
      <chat-widget :discussion-id="classroom.discussion_id" v-if="mobile"/>
    </template>
    <template slot="right">
      <chat-widget :show-loader="false" :discussion-id="classroom.discussion_id"/>
    </template>
  </DefaultLayout>
</template>
<script>
import SubjectObject from '../components/Subject/SubjectView.vue'
import NextConferences from "../components/Conference/NextConferences";
import SubjectList from "../components/Subject/SubjectList";
import LeftSidebarBottom from '../components/LayoutPartials/LeftSideBarBottom'
import LeftSidebarTop from '../components/LayoutPartials/LeftSideBarTop'
import QuestionsWidget from '../components/Questions/QuestionsWidget'
import {mapGetters} from 'vuex'
import DefaultLayout from "@/Layout/DefaultLayout";
import moment from 'moment'
import ChatWidget from "@/components/Chat/ChatWidget";

export default {
  components: {
    ChatWidget,
    DefaultLayout,
    SubjectObject,
    SubjectList,
    NextConferences,
    QuestionsWidget,
    LeftSidebarTop,
    LeftSidebarBottom
  },
  data() {
    return {}
  },
  methods: {
    moment
  },
  computed: {
    ...mapGetters({
      user: 'user',
      classroom: 'classroom',
      stats: 'dashboard/stats',
      last_content: 'dashboard/last_content',
      loading: 'dashboard/loading',
      mobile: 'mobile'
    }),
    badge() {
      if (!this.last_content) return
      switch (this.last_content.type) {
        case 'course':
          return 'Cours'
        case 'course_complete':
          return 'Cours complet'
        case 'video':
          return 'Vidéo'
        case 'exercise':
          return 'Exercice'
        case 'quiz':
          return 'Quiz'
      }
    },
    content_link() {
      if (!this.last_content) return
      switch (this.last_content.type) {
        case 'course':
          return {
            name: 'course',
            params: {slug: this.last_content.lesson_slug}
          }
        case 'course_complete':
          return {
            name: 'course',
            params: {slug: this.last_content.lesson_slug},
            query: {complete: true}
          }
        case 'video':
          return {
            name: 'lesson-video',
            params: {slug: this.last_content.lesson_slug},
            query: {video: this.last_content.id}
          }
        case 'exercise':
          return {
            name: 'exercise-view',
            params: {lesson_slug: this.last_content.lesson_slug, id: this.last_content.id},
          }
        case 'quiz':
          return {
            name: 'lesson-quiz',
            params: {slug: this.last_content.lesson_slug}
          }
      }
    },
    paymentSuccess() {
      return this.$route.query.payment === 'success'
    }
  },
  created() {
    this.$store.dispatch('dashboard/fetchData')
  }
}
</script>
<style lang="scss" scoped>


</style>
